export const CHARGE_NAME_MISSING = 'chargeNameMissing'

export const FLAT_FEE_MISSING = 'flatFeeMissing'

export const LSA_NOT_READY_CODES = Object.freeze([CHARGE_NAME_MISSING, FLAT_FEE_MISSING])

export const CHARGE_NAME_NOT_REQUIRED = Object.freeze({ required: false })

export const PICK_CHARGE_NAME_HINT = 'Pick how this client will be charged before sending the agreement.'
